import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  const sections = [
    { title: t('landing.privacySectionWhoWeAreTitle'), body: t('landing.privacySectionWhoWeAreBody') },
    { title: t('landing.privacySectionDataWeCollectTitle'), body: t('landing.privacySectionDataWeCollectBody') },
    { title: t('landing.privacySectionHowWeUseDataTitle'), body: t('landing.privacySectionHowWeUseDataBody') },
    { title: t('landing.privacySectionLegalBasisTitle'), body: t('landing.privacySectionLegalBasisBody') },
    { title: t('landing.privacySectionDataRetentionTitle'), body: t('landing.privacySectionDataRetentionBody') },
    { title: t('landing.privacySectionCookiesTitle'), body: t('landing.privacySectionCookiesBody') },
    { title: t('landing.privacySectionYourRightsTitle'), body: t('landing.privacySectionYourRightsBody') },
    { title: t('landing.privacySectionInternationalTransfersTitle'), body: t('landing.privacySectionInternationalTransfersBody') },
    { title: t('landing.privacySectionThirdPartyServicesTitle'), body: t('landing.privacySectionThirdPartyServicesBody') },
    { title: t('landing.privacySectionChangesTitle'), body: t('landing.privacySectionChangesBody') },
    { title: t('landing.privacySectionContactTitle'), body: t('landing.privacySectionContactBody') },
  ];

  return (
    <>
      <Helmet>
        <title>{t('landing.privacyMetaTitle')}</title>
      </Helmet>

      <Box py={16} minH="100vh">
        <Container maxW="3xl">
          <VStack gap={10} align="start">

            {/* Back */}
            <RouterLink to="/" style={{ color: '#3182ce', fontSize: '0.875rem' }}>
              {t('landing.backToHome')}
            </RouterLink>

            {/* Header */}
            <VStack gap={2} align="start">
              <Heading as="h1" size="2xl">{t('landing.privacyTitle')}</Heading>
              <Text color="gray.500" fontSize="sm">{t('landing.lastUpdatedFebruary2026')}</Text>
            </VStack>

            {/* Intro */}
            <Text fontSize="lg" color="gray.600">
              {t('landing.privacyIntro')}
            </Text>

            {/* Sections */}
            {sections.map(({ title, body }) => (
              <VStack key={title} align="start" gap={3} w="full">
                <Heading as="h2" size="md">{title}</Heading>
                <Text color="gray.600" whiteSpace="pre-line">{body}</Text>
              </VStack>
            ))}

          </VStack>
        </Container>
      </Box>
    </>
  );
};

export default PrivacyPage;
